import React, { useState, useRef, useEffect } from 'react';
import styles from './chatbot.module.css';
import { API_URL } from '../../config';

const GREETING = '¡Hola! 👋 Soy el asistente virtual de Kredilibranza. ¿En qué puedo ayudarte hoy?';
const MAX_HISTORY_TURNS = 8;

function ChatBotPage() {
  const [messages, setMessages] = useState([{ role: 'bot', content: GREETING }]);
  const [inputValue, setInputValue] = useState('');
  const [isTyping, setIsTyping] = useState(false);
  const messagesEndRef = useRef(null);

  const handleSendMessage = async () => {
    if (inputValue.trim() === '') return;
    const userMessage = { role: 'user', content: inputValue };
    const history = messages.slice(-MAX_HISTORY_TURNS).map((m) => ({
      role: m.role === 'user' ? 'user' : 'assistant',
      content: m.content,
    }));
    setMessages((prev) => [...prev, userMessage]);
    setInputValue('');
    setIsTyping(true);
    try {
      const botResponse = await getBotResponse(inputValue, history);
      setMessages((prevMessages) => [...prevMessages, botResponse]);
    } catch (error) {
      console.error('Error al obtener respuesta del bot:', error);
      setMessages((prevMessages) => [...prevMessages, { role: 'bot', content: 'Error al obtener respuesta del bot.' }]);
    } finally {
      setIsTyping(false);
    }
  };

  const getBotResponse = async (message, history) => {
    try {
      const response = await fetch(`${API_URL}/generate-answer/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ question: message, history }),
      });
      if (!response.ok) {
        throw new Error('Error en la respuesta del servidor');
      }
      const data = await response.json();
      return { role: 'bot', content: data.answer };
    } catch (error) {
      throw error;
    }
  };

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, isTyping]);

  return (
    <div className={styles.chatContainer}>
      <div className={styles.chatWindow}>
        <div className={styles.messagesContainer}>
          {messages.map((message, index) => (
            <div key={index} className={styles.messageRow}>
              {message.role === 'bot' && (
                <img src="/img/KL.png" alt="" className={styles.avatar} aria-hidden="true" />
              )}
              <div
                className={`${styles.message} ${
                  message.role === 'user' ? styles.messageUser : styles.messageBot
                }`}
              >
                {message.content}
              </div>
            </div>
          ))}
          {isTyping && (
            <div className={styles.messageRow}>
              <img src="/img/KL.png" alt="" className={styles.avatar} aria-hidden="true" />
              <div className={`${styles.message} ${styles.messageBot} ${styles.typingBubble}`}>
                <span className={styles.typingDot} />
                <span className={styles.typingDot} />
                <span className={styles.typingDot} />
              </div>
            </div>
          )}
          <div ref={messagesEndRef} />
        </div>

        <div className={styles.inputContainer}>
          <input
            type="text"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            placeholder="Escribe tu mensaje..."
            onKeyPress={(e) => e.key === 'Enter' && handleSendMessage()}
            className={styles.inputField}
            disabled={isTyping}
          />
          <button onClick={handleSendMessage} className={styles.sendButton} disabled={isTyping}>
            Enviar
          </button>
        </div>
      </div>
    </div>
  );
}

export default ChatBotPage;
